export class BltSideNavConstant {
  static readonly CHANGE_PASSWORD: string = "Change password";
  static readonly SIGN_OUT: string = "Sign out";
}
